import { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import PollCard from "../components/PollCard";
import { ArrowLeft } from "lucide-react";

const TrendingTopicPage = () => {
  const { keyword } = useParams();
  const navigate = useNavigate();
  const [polls, setPolls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/trending/${encodeURIComponent(keyword)}`);
        setPolls(response.data || []);
      } catch {
        toast.error("Unable to load topic polls.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [keyword]);

  const updatePoll = useCallback((updated) => {
    setPolls((prev) => prev.map((p) => (p.id === updated.id ? updated : p)));
  }, []);

  const removePoll = useCallback((pollId) => {
    setPolls((prev) => prev.filter((p) => p.id !== pollId));
  }, []);

  return (
    <div className="space-y-6" data-testid="trending-topic-page">
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate("/trending")}
          className="h-9 w-9 rounded-full border border-border flex items-center justify-center hover:bg-accent"
          data-testid="trending-topic-back"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div>
          <h2 className="text-2xl font-semibold" data-testid="trending-topic-title">
            {decodeURIComponent(keyword)}
          </h2>
          <p className="text-sm text-muted-foreground" data-testid="trending-topic-subtitle">
            Polls mentioning this topic in the last 24 hours.
          </p>
        </div>
      </div>

      {loading ? (
        <div className="text-sm text-muted-foreground" data-testid="trending-topic-loading">
          Loading polls...
        </div>
      ) : polls.length === 0 ? (
        <div
          className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground"
          data-testid="trending-topic-empty"
        >
          No polls found for this topic.
        </div>
      ) : (
        <div className="space-y-4" data-testid="trending-topic-polls">
          {polls.map((poll) => (
            <PollCard key={poll.id} poll={poll} onUpdate={updatePoll} onRemove={removePoll} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TrendingTopicPage;
